/**
 * V154 — Consistent "received" timestamp formatting for lead cards.
 *
 * Example output: "24 Sep 2026, 10:26 PM"
 * Falls back gracefully if the date is missing / malformed.
 *
 * Note: We hand-roll the month lookup because the day-first locales that
 * ship with Node/browsers (en-GB, en-IN, en-AU) all emit "Sept" as the
 * short-form for September, while the user's spec example uses "Sep".
 * en-US emits "Sep" but forces month-first ordering. So we compose the
 * date manually and only delegate the time portion to the locale formatter.
 */
const _MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                 "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function _formatTime12h(d) {
    // Manual "10:26 PM" so the output is locale-independent and matches
    // the spec example verbatim.
    let h = d.getHours();
    const m = d.getMinutes();
    const suffix = h >= 12 ? "PM" : "AM";
    h = h % 12; if (h === 0) h = 12;
    const mm = m < 10 ? `0${m}` : String(m);
    return `${h}:${mm} ${suffix}`;
}

function _pad2(n) { return n < 10 ? `0${n}` : String(n); }

export function formatReceivedAt(iso) {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        if (isNaN(d.getTime())) return "";
        return `${_pad2(d.getDate())} ${_MONTHS[d.getMonth()]} ${d.getFullYear()}, ${_formatTime12h(d)}`;
    } catch (_e) {
        return "";
    }
}

/** Compact date only ("24 Sep 2026") for table columns. */
export function formatReceivedDateShort(iso) {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        if (isNaN(d.getTime())) return "";
        return `${_pad2(d.getDate())} ${_MONTHS[d.getMonth()]} ${d.getFullYear()}`;
    } catch (_e) {
        return "";
    }
}
